export default {
  description:
    "Utilisez le code : {{code}} pour bénéficier d'une réduction sur vos {{count}} prochaines commandes ici.",
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Commande',
    },
  },
  savings: {
    percentage: 'Vous économisez au total {{totalSaved}}%',
    fixed: 'Vous économisez au total {{totalSaved}}',
  },
  apply: 'Appliquer',
  applied: 'Appliqué',
  remove: 'Supprimer',
  custom_button: {
    done: 'Terminer',
  },
};
